import React from 'react';
import { SparklesIcon, MailIcon, LinkedinIcon, TwitterIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-300 py-12" data-id="element-64">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-65">
        <div className="grid md:grid-cols-4 gap-8 mb-8" data-id="element-66">
          {/* Brand */}
          <div className="col-span-1" data-id="element-67">
            <div className="flex items-center gap-2 mb-4" data-id="element-68">
              <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-purple-500 rounded-lg flex items-center justify-center" data-id="element-69">
                <SparklesIcon className="w-6 h-6 text-white" data-id="element-70" />
              </div>
              <span className="text-xl font-bold text-white" data-id="element-71">SalesMax</span>
            </div>
            <p className="text-sm text-gray-400" data-id="element-72">
              AI-powered go-to-market engine for modern businesses.
            </p>
          </div>
          {/* Services */}
          <div data-id="element-73">
            <h4 className="text-white font-semibold mb-4" data-id="element-74">Services</h4>
            <ul className="space-y-2 text-sm" data-id="element-75">
              <li data-id="element-76">
                <a href="#" className="hover:text-white transition-colors" data-id="element-77">
                  Brand & Positioning
                </a>
              </li>
              <li data-id="element-78">
                <a href="#" className="hover:text-white transition-colors" data-id="element-79">
                  Demand Generation
                </a>
              </li>
              <li data-id="element-80">
                <a href="#" className="hover:text-white transition-colors" data-id="element-81">
                  Sales Assist
                </a>
              </li>
              <li data-id="element-82">
                <a href="#" className="hover:text-white transition-colors" data-id="element-83">
                  Analytics
                </a>
              </li>
            </ul>
          </div>
          {/* Company */}
          <div data-id="element-84">
            <h4 className="text-white font-semibold mb-4" data-id="element-85">Company</h4>
            <ul className="space-y-2 text-sm" data-id="element-86">
              <li data-id="element-87">
                <a href="#" className="hover:text-white transition-colors" data-id="element-88">
                  About Us
                </a>
              </li>
              <li data-id="element-89">
                <a href="#" className="hover:text-white transition-colors" data-id="element-90">
                  Case Studies
                </a>
              </li>
              <li data-id="element-91">
                <a href="#" className="hover:text-white transition-colors" data-id="element-92">
                  Pricing
                </a>
              </li>
              <li data-id="element-93">
                <a href="#" className="hover:text-white transition-colors" data-id="element-94">
                  Contact
                </a>
              </li>
            </ul>
          </div>
          {/* Contact */}
          <div data-id="element-95">
            <h4 className="text-white font-semibold mb-4" data-id="element-96">Get in Touch</h4>
            <div className="space-y-3" data-id="element-97">
              <a href="mailto:support@salesmax.pro" className="flex items-center gap-2 text-sm hover:text-white transition-colors" data-id="element-98">
                <MailIcon className="w-4 h-4" data-id="element-99" />
                support@salesmax.pro
              </a>
              <div className="flex gap-3 mt-4" data-id="element-100">
                <a href="#" className="w-8 h-8 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors" data-id="element-101">
                  <LinkedinIcon className="w-4 h-4" data-id="element-102" />
                </a>
                <a href="#" className="w-8 h-8 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-400 transition-colors" data-id="element-103">
                  <TwitterIcon className="w-4 h-4" data-id="element-104" />
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* Bottom bar */}
        <div className="border-t border-gray-800 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-gray-400" data-id="element-105">
          <p data-id="element-106">&copy; 2025 SalesMax. All rights reserved.</p>
          <div className="flex gap-6" data-id="element-107">
            <a href="#" className="hover:text-white transition-colors" data-id="element-108">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-109">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}